module.exports = __webpack_public_path__ + "static/media/get-into-action.bea96709.jpg";